import { lazy, Suspense } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";

import App from "../App";

import { 
  APIINTEGRATION, APIINTEGRATION_LINK, AUTHERIZATION, AUTHERIZATION_LINK, DOCS, EMBEDDEDREWARD, EMBEDEDCODE, EMBEDEDCODE_LINK, FILE_UPLOAD_LINK, GAMIFICATION_LINK, PIXEL, PIXEL_LINK, SDK, SDK_LINK 
} from "./RouterConstant";

import ErrorBoundary from "../hoc/ErrorBoundary";

import Error from "../component/Error";
import Spinner from "../component/Spinner";

const Page = lazy(() => import("../pages"));
const AuthorizationPage = lazy(() => import("../pages/Authorization"));
const PixelPage = lazy(() => import("../pages/Pixel"));
const APIIntegrationPage = lazy(() => import("../pages/ApiIntegration"));
const EmbededCodePage = lazy(() => import("../pages/EmbededCode"));
const EmbeddedRewardPage = lazy(() => import("../pages/EmbeddedReward"));
const SDKPage = lazy(() => import("../pages/SDK"));
const Gamification = lazy(() => import("../pages/Gamification"));
const FileUpload = lazy(() => import("../pages/FileUpload"));

// Error boundary wrapper component
const WrapWithErrorBoundary = ({ children, skeleton }) => (
  <ErrorBoundary fallback={<Error />}>
    <Suspense fallback={skeleton || <Spinner />}>{children}</Suspense>
  </ErrorBoundary>
);

export const routes = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to={DOCS} replace={true} />,
  },
  {
    path: DOCS,
    element: <App />,
    errorElement: <Error />,
    children: [
      {
        path: "",
        element: <WrapWithErrorBoundary><Page /></WrapWithErrorBoundary>,
        errorElement: <Error />,
      },
      {
        path: AUTHERIZATION,
        element: <WrapWithErrorBoundary><AuthorizationPage /></WrapWithErrorBoundary>,
        errorElement: <Error />,
      },
      {
        path: AUTHERIZATION_LINK,
        element: <WrapWithErrorBoundary><AuthorizationPage /></WrapWithErrorBoundary>,
        errorElement: <Error />,
      },
      {
        path: EMBEDEDCODE,
        element: <WrapWithErrorBoundary><EmbededCodePage /></WrapWithErrorBoundary>,
        errorElement: <Error />,
      },
      {
        path: EMBEDDEDREWARD,
        element: <WrapWithErrorBoundary><EmbeddedRewardPage /></WrapWithErrorBoundary>,
        errorElement: <Error />,
      },
      {
        path: EMBEDEDCODE_LINK,
        element: <WrapWithErrorBoundary><EmbededCodePage /></WrapWithErrorBoundary>,
        errorElement: <Error />,
      },
      {
        path: APIINTEGRATION,
        element: <WrapWithErrorBoundary><APIIntegrationPage /></WrapWithErrorBoundary>,
        errorElement: <Error />,
      },
      {
        path: APIINTEGRATION_LINK,
        element: <WrapWithErrorBoundary><APIIntegrationPage /></WrapWithErrorBoundary>,
        errorElement: <Error />,
      },
      {
        path: PIXEL,
        element: <WrapWithErrorBoundary><PixelPage /></WrapWithErrorBoundary>,
        errorElement: <Error />,
      },
      {
        path: PIXEL_LINK,
        element: <WrapWithErrorBoundary><PixelPage /></WrapWithErrorBoundary>,
        errorElement: <Error />,
      },
      {
        path: SDK,
        element: <WrapWithErrorBoundary><SDKPage /></WrapWithErrorBoundary>,
        errorElement: <Error />,
      },
      {
        path: SDK_LINK,
        element: <WrapWithErrorBoundary><SDKPage /></WrapWithErrorBoundary>,
        errorElement: <Error />,
      },
      {
        path: GAMIFICATION_LINK,
        element: <WrapWithErrorBoundary><Gamification /></WrapWithErrorBoundary>,
        errorElement: <Error />,
      },
      {
        path: FILE_UPLOAD_LINK,
        element: <WrapWithErrorBoundary><FileUpload /></WrapWithErrorBoundary>,
        errorElement: <Error />,
      },
    ],
  }
]);
